import React, { useContext, useEffect, useReducer, useState } from 'react';
import styled from 'styled-components';

export const UserRow: React.FC<{
    id?: any;
    email?: string;
    role?: string;
    canAccess?: string;
  }> = ({id, email, role, canAccess}) => {

    const onClick = (e:any) => {
      //console.log('user: ', id);
    }

    return (<>
        <DataRow onClick={onClick}>
            <Column><span>{email}</span></Column>
            <Column><span>{role}</span></Column>
            <Column><span>{canAccess}</span></Column>
        </DataRow>
    </>);
  };

  export const BaseRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    grid-column-gap: 2em;
    cursor: pointer;
  `;

  const DataRow = styled(BaseRow)`
  :not(:last-child) {
    margin-bottom: 1em;
  }

  :hover {
    background-color: #3c140c;
    border-radius: 4px;
  }
 `;

  export const Column = styled.div`
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: center;

    span {
        margin:auto;
    }
  `;